import { ReportParams } from './../models/interfaces/report-request-params.model';
import { VehicleReportsIds } from '../models/interfaces/vehicle-by-reports.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AuthService } from '../../core/auth.service';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/components/common/messageservice';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  urlVehicles = environment.baseUrl + environment.api + 'reports/vehiclesForReport/' + environment.surfix;
  urlSets = environment.baseUrl + environment.api + 'reports/vehiclesForReport/' + environment.surfix;
  urlVehiclesReportsIds = environment.baseUrl + environment.api + 'vehicles/reports';
  urlGroups = environment.baseUrl + environment.api + 'vehicles_groups' + environment.surfix;

  urlDrivers = environment.baseUrl + environment.api + 'drivers' + environment.surfix;
  urlReportRetrieve = environment.baseUrl + environment.api + 'reports/retrieve?id=';
  urlReports = environment.baseUrl + environment.api + 'reports' + environment.surfix;

  closeSideNavSubject: Subject<any> = new Subject();
  filterByVehicleTypeId: Subject<any> = new Subject();
  filterByVehicleGroupId: Subject<any> = new Subject();
  setVehicleId: Subject<any> = new Subject();

  public filterByTypeIsEnable = false;
  public filterTypeId = 0;
  public filterByGroupIsEnable = false;
  public filterGroupIdArray = [];

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {}

  getVehicles(reportId): Observable<any> {
    return this.http.get(this.urlVehicles + reportId, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  getSets(reportId): Observable<any> {
    return this.http.get(this.urlSets + reportId, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  getDrivers(): Observable<any> {
    return this.http.get(this.urlDrivers, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  getVehiclesGroups() {
    return this.http.get(this.urlGroups, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  getVehiclesReportsIds() {
    return this.http.get<VehicleReportsIds[]>(this.urlVehiclesReportsIds, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  showServerError() {
    this.messageService.add({
      severity: 'error',
      summary: this.translateService.instant(
        'admin-panel.settings.server_error_summary'
      ),
      detail: this.translateService.instant(
        'admin-panel.settings.server_error_detail'
      ),
      key: 'appMessage',
    });
  }

  getReport<T>(reportId: number, paramsObj: ReportParams): Observable<T> {
    let params = new HttpParams();
    Object.entries(paramsObj).forEach((entry) => {
      let value = entry[1];
      if (value != null) {
        if (value instanceof Date) {
          value = value.setSeconds(0, 0).valueOf() / 1000;
        }
        params = params.append(entry[0], value.toString());
      }
    });
    const url = `${this.urlReports}/${reportId}`;
    return this.http.get<T>(url, {
      headers: this.authService.getJwtAuthHeaders(),
      params,
    });
  }
}
